import type { SpeedDialDesignTokens, SpeedDialTokenSections } from '@primeuix/themes/types/speeddial';

export const root: SpeedDialTokenSections.Root = {
    gap: '0.5rem',
    transitionDuration: '{transition.duration}'
};

export const css: SpeedDialTokenSections.CSS = ``;

export default {
    root,
    css
} satisfies SpeedDialDesignTokens;
